export default __webpack_public_path__ + "static/media/donacion_alimento.8ed1e302.png";